import s from './Forbidden.scss'

const Forbidden = () => (
  <section className={s.container}>
    <span className={s.text}>403</span>
  </section>
)

export default Forbidden
